import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    CreditToBalanceRequest,
    CreditToBalanceResponse,
} from '@eightcap/core';
import { ApiBaseService } from '../crud.service';

@Injectable()
export class CreditToBalanceService extends ApiBaseService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/service/metatrader/credit_to_balance');
    }

    post(
        data: CreditToBalanceRequest[]
    ): Observable<CreditToBalanceResponse[]> {
        return this.httpClient.post<CreditToBalanceResponse[]>(this.basePath, {
            data,
        });
    }
}
